'use strict';

var _ = require('underscore');
var STATIC = require('./statics');
var viewToModelMappingUtil = require('js/lib/components/CustomMaker/viewToModelMappingUtil');

function getIsWaitingForViewer(storeData) {
  return storeData.waitingForViewer;
}

function getIsPreviewing(storeData) {
  return storeData.isPreviewing;
}

function getPreventAllInput(storeData) {
  return storeData.preventAllInput;
}

///////////
//
// Hotspots
//
///////////
function getNewHotspotId(storeData) {
  // jshint unused:false
  return _.uniqueId();
}

function getCurrentHotspotId(storeData) {
  return storeData.currentHotspotId;
}

function getHotspot(storeData, hotspotId) {
  return storeData.hotspots[hotspotId] || {};
}

function getHotspots(storeData) {
  return storeData.hotspots;
}

function getHotspotIds(storeData) {
  return _.keys(getHotspots(storeData));
}

function getHotspotCount(storeData) {
  return getHotspotIds(storeData).length;
}

function hasCurrentHotspot(storeData) {
  return getCurrentHotspotId(storeData) !== -1;
}

function hasHotspot(storeData, hotspotId) {
  var hotspots = getHotspots(storeData);
  return !_.isUndefined(hotspots[hotspotId]);
}

function modelHasOneOrMoreHotspots(storeData) {
  return getHotspotCount(storeData) > 0;
}

function isCurrentHotspot(storeData, hotspotId) {
  return getCurrentHotspotId(storeData) === hotspotId;
}

function getCurrentHotspot(storeData) {
  return getHotspot(storeData, storeData.currentHotspotId);
}

function getLastId(storeData, ids) {
  return _.max(ids, function findMaxHotspotId(hotspotId) {
    return parseInt(hotspotId, 10);
  });
}

function getLastHotspotId(storeData) {
  if(modelHasOneOrMoreHotspots(storeData)) {
    return getLastId(storeData, getHotspotIds(storeData));
  }
}

function getLastHotspotIdExcludingId(storeData, excludId) {
  var hotspotIds = getHotspotIds(storeData);
  return getLastId(storeData, _.without(hotspotIds, excludId));
}

function getLastHotspot(storeData) {
  return getHotspot(getLastHotspotId(storeData));
}

function hotspotTypeInModel(storeData, type) {
  if(modelHasOneOrMoreHotspots(storeData)) {
    return !!_.find(getHotspots(storeData), function findByType(hotspot) {
      return hotspot.type === type;
    });
  }
  return false;
}

function hotspotHasImage(storeData, hotspotId) {
  var hotspot = getHotspot(storeData, hotspotId);
  return (hotspot && !_.isEmpty(hotspot.image));
}

// This should be depricated the moment we support hotspot specific
// engrave depths
function getGlobalEngraveDepth(storeData) {
  var currentHotspot = getCurrentHotspot(storeData);
  return _.isUndefined(currentHotspot.engrave_depth) ? STATIC.ENGRAVE_DEFAULTS.DEPTH : parseFloat(currentHotspot.engrave_depth);
}

function getCurrentEngraveDepth(storeData) {
  return getCurrentHotspot(storeData).engrave_depth;
}

function getEngraveMultiplier(storeData, endgraveDepth) {
  return endgraveDepth > 0 ? STATIC.ENGRAVE_DEFAULTS.EMBOSS_MULTIPLIER : STATIC.ENGRAVE_DEFAULTS.ENGRAVE_MULTIPLIER;
}

function getCurrentEngraveMultiplier(storeData) {
  return getEngraveMultiplier(storeData, getCurrentEngraveDepth(storeData));
}

function calcEngraveDepth(storeData, multiplier, depth) {
  return multiplier * Math.abs(parseFloat(depth));
}

function isShopperView(storeData) {
  return storeData.viewMode === STATIC.VIEW_MODES.SHOPPER;
}

function getBaseFormAction(storeData) {
  return storeData.formActions.baseAction;
}

function getCustomizedFormAction(storeData) {
  return storeData.formActions.customizedAction;
}

function getModelDataForViewer(storeData, forRealtime) {
  return viewToModelMappingUtil.formatModelDataForViewer(storeData, forRealtime);
}

/**
 * Checks if the current hotspot is of a specific type
 * @param storeData
 * @param type
 * @return {boolean}
 */
function isCurrentHotspotType(storeData, type) {
  var currentHotspot = getCurrentHotspot(storeData);
  return currentHotspot && currentHotspot.type === type;
}

var storeUtils = {

	getIsWaitingForViewer: getIsWaitingForViewer,
	getIsPreviewing: getIsPreviewing,
	getPreventAllInput: getPreventAllInput,
  getNewHotspotId: getNewHotspotId,
  getCurrentHotspotId: getCurrentHotspotId,
  getHotspot: getHotspot,
  getHotspots: getHotspots,
  getHotspotIds: getHotspotIds,
  getHotspotCount: getHotspotCount,
  hasCurrentHotspot: hasCurrentHotspot,
  hasHotspot: hasHotspot,
  modelHasOneOrMoreHotspots: modelHasOneOrMoreHotspots,
  isCurrentHotspot: isCurrentHotspot,
	getCurrentHotspot: getCurrentHotspot,
	getLastHotspotId: getLastHotspotId,
  getLastHotspotIdExcludingId: getLastHotspotIdExcludingId,
  getLastHotspot: getLastHotspot,
  hotspotTypeInModel: hotspotTypeInModel,
  getGlobalEngraveDepth: getGlobalEngraveDepth,
  getCurrentEngraveMultiplier: getCurrentEngraveMultiplier,
  getCurrentEngraveDepth: getCurrentEngraveDepth,
  getEngraveMultiplier: getEngraveMultiplier,
  calcEngraveDepth: calcEngraveDepth,
  isShopperView: isShopperView,
  getBaseFormAction: getBaseFormAction,
  getCustomizedFormAction: getCustomizedFormAction,
  getModelDataForViewer: getModelDataForViewer,
  hotspotHasImage: hotspotHasImage,
  isCurrentHotspotType: isCurrentHotspotType
};

module.exports = storeUtils;
